<template>
  <div class="login-bg">
    <div
      v-if="!($vuetify.breakpoint.mobile && signupDialog)"
      class="login-container d-flex flex-row"
    >
      <v-row>
        <v-col
          cols="12"
          md="4"
          sm="12"
          class="d-flex flex-column justify-center"
          style="background-color: white"
        >
          <div
            class="d-flex flex-column justify-center align-center pa-6 py-10"
          >
            <img :src="logoUrl" style="width: 175px" />
            <v-form class="mx-md-5 mt-10" @submit.prevent="loginSubmit">
              <v-text-field
                v-model="username"
                name="Username"
                label="Username or Email"
                class="mb-4 mt-2"
                hide-details
                background-color="grey lighten-3"
                solo
                dense
                flat
                required
              ></v-text-field>
              <v-text-field
                v-model="password"
                name="Password"
                label="Password"
                class="mt-4"
                :type="showPassword ? 'text' : 'password'"
                hide-details
                background-color="grey lighten-3"
                solo
                dense
                flat
                required
                :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                @click:append="toggleShowPassword"
              ></v-text-field>
              <div>
                <a
                  class="text-tiny"
                  style="font-style: italic"
                  @click="redirectForgotPassword"
                  >Forgot Password?</a
                >
              </div>
              <v-btn
                class="mt-8 mb-8"
                block
                rounded
                depressed
                color="primary"
                type="loginSubmit"
                >Login</v-btn
              >
              <div class="link">
                <a class="text-tiny" @click="redirectSignUp"
                  >Don't have an account? Sign Up Here!</a
                >
              </div>
            </v-form>
          </div>
        </v-col>
        <v-col
          v-if="!$vuetify.breakpoint.mobile"
          cols="12"
          md="8"
          sm="0"
          class="d-flex flex-column justify-center align-center graphic-bg"
        >
          <img :src="graphicUrl" class="login-image" />
          <h1 class="font-weight-medium text-center white--text mt-4">
            Property management<br />made easier
          </h1>
        </v-col>
      </v-row>
    </div>
    <v-dialog
      v-if="!$vuetify.breakpoint.mobile"
      v-model="signupDialog"
      transition="dialog-bottom-transition"
      width="500"
      persistent
    >
      <SignupV2 @hideSignup="hideSignup"></SignupV2>
    </v-dialog>
    <div v-else-if="signupDialog">
      <SignupV2 @hideSignup="hideSignup"></SignupV2>
    </div>
    <v-snackbar v-model="snackbar" light>
      {{ snackMessage }}
      <template v-slot:action="{ attrs }">
        <v-btn color="pink" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import SignupV2 from '../components/home/SignupV2.vue'

export default {
  components: {
    SignupV2
  },
  data() {
    return {
      username: '',
      password: '',
      snackMessage: '',
      snackbar: false,
      timeout: 5000,
      loading: false,
      signupDialog: false,
      showPassword: false
    }
  },
  computed: {
    ...mapState('auth', ['loggingIn', 'loginError', 'loginSuccessful']),
    property() {
      return this.$store.getters['properties/getProperty']
    },
    logoUrl() {
      return `${process.env.BASE_URL}images/logo_text_bottom.png`
    },
    graphicUrl() {
      return `${process.env.BASE_URL}images/person-coffee.png`
    }
  },
  mounted() {
    if (localStorage.getItem('token')) {
      if (this.property) {
        if (
          this.property.status === 'rejected' ||
          new Date(this.property.subscriptionEnd) <= new Date()
        ) {
          this.$router.replace('/expired')
        } else {
          this.$router.replace('/dashboard')
        }
      } else {
        this.$router.replace('/new')
      }
    }
  },
  methods: {
    ...mapActions('auth', ['doLogin']),
    async loginSubmit() {
      this.loading = true
      return this.doLogin({
        username: this.username,
        password: this.password
      }).then(async (response) => {
        this.loading = false
        if (response.success) {
          const url = new URL(window.location.href)
          const messengerAccountLinkingToken = url.searchParams.get(
            'account_linking_token'
          )
          const messengerRedirectUri = url.searchParams.get('redirect_uri')

          if (messengerRedirectUri && messengerAccountLinkingToken) {
            window.location.href =
              messengerRedirectUri +
              `&authorization_code=${encodeURIComponent(this.username)}`
          } else if (localStorage.getItem('token')) {
            window.location.reload()
          }
        } else {
          this.snackbar = true
          this.snackMessage = response.message
        }
      })
    },
    redirectSignUp() {
      // this.$router.replace('/signup')
      // use signup v2
      this.signupDialog = true
    },
    hideSignup() {
      this.signupDialog = false
    },
    redirectForgotPassword() {
      this.$router.replace('/forgotpassword')
    },
    toggleShowPassword() {
      this.showPassword = !this.showPassword
    }
  }
}
</script>

<style scoped>
p {
  margin-bottom: 0;
}
.link {
  text-align: center;
}
.link a {
  text-decoration: none;
  font-size: 20px;
}
.display-1 {
  letter-spacing: 0.5px;
}
.subtitle-2 {
  letter-spacing: 3px;
}
.login-container {
  height: 100vh;
}
.login-bg {
  height: 100vh;
  background: white;
}
.graphic-bg {
  background: #662d91;
  background: -moz-linear-gradient(-45deg, #41129d 0%, #662d91 100%);
  background: -webkit-gradient(
    left top,
    right bottom,
    color-stop(0%, #41129d),
    color-stop(100%, #662d91)
  );
  background: -webkit-linear-gradient(-45deg, #41129d 0%, #662d91 100%);
  background: -o-linear-gradient(-45deg, #41129d 0%, #662d91 100%);
  background: -ms-linear-gradient(-45deg, #41129d 0%, #662d91 100%);
  background: -webkit-linear-gradient(315deg, #41129d 0%, #662d91 100%);
  background: -o-linear-gradient(315deg, #41129d 0%, #662d91 100%);
  background: linear-gradient(135deg, #41129d 0%, #662d91 100%);
}
.login-image {
  max-height: 45vh;
}
</style>
